/**
 * Font Helper Utility
 *
 * This utility provides a simple function to use in MUI sx props
 * to ensure consistent font family usage across the app.
 *
 * Usage in components:
 * Instead of: fontFamily: 'Inter'
 * Use: ...fontFamily()
 */

import { getFontFamily } from '../config/fonts';

/**
 * Returns an object with fontFamily that can be spread into MUI sx props
 *
 * @example
 * <Typography sx={{ ...fontFamily(), fontSize: 16 }}>Text</Typography>
 */
export const fontFamily = () => ({
  fontFamily: getFontFamily(),
});

/**
 * Returns just the font family string for inline usage
 *
 * @example
 * <Typography sx={{ fontFamily: font(), fontSize: 16 }}>Text</Typography>
 */
export const font = () => getFontFamily();
